/* eslint-disable no-plusplus */
/* eslint-disable one-var */
/* eslint-disable react/require-default-props */
/* eslint-disable consistent-return */
/* eslint-disable func-names */
/* eslint-disable prefer-const */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable no-else-return */
/* eslint-disable object-shorthand */
import { Chip } from "@material-ui/core";
import React, { SetStateAction } from "react";
import { Layout, Layouts } from "react-grid-layout";
import { v4 as uuidv4 } from "uuid";
import { QueueCallState } from "../QueueLeaderboard";
import { MetricObject } from "../QueueWidgetContainer";

export const chartBgs = [
      "#007BFF",   // blue
      "#35C75A",   // green
      "#27B2C8",   // cyan
      "#AF53DE",   // purple
      "#FF9503",   // orange
      "#E6895E",   // coral
      "#FF3A30",   // red
      "#007BFF99", // blue
      "#35C75A99", // green
      "#27B2C899", // cyan
      "#AF53DE99", // purple
      "#FF950399", // orange
      "#E6895E99", // coral
      "#FF3A3099", // red
      "#007BFF44", // blue
      "#35C75A44", // green
      "#27B2C844", // cyan
      "#AF53DE44", // purple
      "#FF950344", // orange
      "#E6895E44", // coral
      "#FF3A3044"  // red
    ]
export interface BaseWidget {
    dashboardId?: string;
    widgetId?: string;
    key?: string;
    label?: string;
    title?: string;
    description?: string;
    widgetType?: "kpi" | "quick" | "customized";
    dimensionType?: "users" | "queues" | "departments";
    category?: "users" | 'queue' | "performance" | "CSAT" | "ecosystem" | "custom" | "misc" | "DIY";
    validationRequirements?: string[];
    metrics?: string[];
    quickWidgetType?: string;
    metricValues?: string[]
    metatags?: string;
    component: React.ComponentType<any>;
    propGetter?: (props: Partial<Widget>) => {[key: string]: any};
    visualType?: "bar" | "donut" | "pie" | "grid" | "text";
    layout?: {
        xxs: Layout,
        xs: Layout,
        sm: Layout,
        md: Layout,
        lg: Layout
    }
    cosmetics?: {
      bgColor?: string;
      color?: string;
    }
}

export interface KPIWidget extends BaseWidget {
    widgetId?: string;
    title?: string;
    key?: string;
    dashboardId?: string;
    widgetType?: "kpi";
    category?: "DIY";
    label?: string;
    dimensionType?: "users" | "queues" | "departments";
    validationRequirements?: string[];
    metrics?: string[];
    metricValues?: string[]
    component: React.ComponentType<any>;
    layout?: {
        xxs: Layout,
        xs: Layout,
        sm: Layout,
        md: Layout,
        lg: Layout
    }
}
export interface CustomWidget extends BaseWidget {
    widgetId?: string;        // uuid
    key?: string;             // widget identifier for render cycle (callResults)
    title?: string;           // custom title set during config
    dashboardId?: string;     // for corresponding dashboard
    widgetType?: "customized";
    dimensionType?: "users" | "queues" | "departments";
    validationRequirements?: string[];
    label?: string;           // UI label for readability
    metrics?: string[];
    metricValues?:string[]
    category?: "DIY";
    component: React.ComponentType<any>;
    visualType?: "bar" | "donut" | "pie";
    layout?: {
        xxs: Layout,
        xs: Layout,
        sm: Layout,
        md: Layout,
        lg: Layout
    }
}

export interface QuickWidget extends BaseWidget {
    widgetId?: string;        // uuid
    key?: string;             // widget identifier for render cycle (callResults)
    title?: string;           // custom title set during config
    widgetType?: "quick";     // type of widget
    dashboardId?: string;     // for corresponding dashboard
    label?: string;           
    component: React.ComponentType<any>;
    visualType?: "bar" | "donut" | "pie" | "text";
    description?: string;
    category?: "users" | 'queue' | "performance" | "CSAT" | "ecosystem" | "custom" | "misc" | "DIY";
    metaTags?: string[];
    dimensionType?: "users" | "queues" | "departments";
    validationRequirements?: string[];
    metrics?: string[];
    metricValues?:string[];
    layout?: {
        xxs: Layout,
        xs: Layout,
        sm: Layout,
        md: Layout,
        lg: Layout
    }
}

export type Widget = KPIWidget | QuickWidget | CustomWidget;

export interface Dashboard {
  _id: string;
  dashboardId: string;
  name: string;
  orgId: string;
  isAdmin?: boolean
}
// resource URL 
const RESOURCE_ADDRESS = "http://192.168.2.70:4321"

// visual breakpoint properties. may be subject to change.
export const breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };

// amount of columns we should be displaying per breakpoint. 
export const columns = { lg: 12, md: 12, sm: 2, xs: 1, xxs: 1 };

// setting the default display properties for each breakpoint. no idea how to make this fluid 
export const newItemLayoutRules = (id: string) => ({
    xxs: { i: id, x: 0, y: 99, w: 1, h: 6, minH: 3, minW: 1, maxW: 1, maxH: 24, },
    xs:  { i: id, x: 0, y: 99, w: 1, h: 6, minH: 3, minW: 1, maxW: 1, maxH: 24  },
    sm:  { i: id, x: 0, y: 99, w: 2, h: 6, minH: 3, minW: 1, maxW: 2, maxH: 24  },
    md:  { i: id, x: 0, y: 99, w: 6, h: 6, minH: 3, minW: 3, maxW: 12, maxH: 24 },
    lg:  { i: id, x: 0, y: 99, w: 6, h: 6, minH: 3, minW: 2, maxW: 12, maxH: 24 }
})
export type Breakpoint = "xxs" | "xs" | "sm" | "md" | "lg"

// GET dashboards
export const getDashboards = (
  setDashboards: React.Dispatch<SetStateAction<Map<string, Dashboard>>>,
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>,
  orgId: string | undefined
) => {
  fetch(`${RESOURCE_ADDRESS}/dashboards?orgId=${orgId}`, {
    method: "GET"
  })
  .then((res) => res.json())
  .then((data) => {
    const dashboardMap = new Map<string, Dashboard>();
    data.forEach((dashboard: Dashboard) => {
      dashboardMap.set(dashboard.dashboardId, dashboard);
    });
    setDashboards(dashboardMap);
  })
  .catch((err) => {
    console.error("ERROR: ", err)
    setLiveDashboardErrorMsg("Failed to load dashboards.")
  });
}

// GET widgets
export const getWidgets = (
  setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>,
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>,
  selectedDashboard: Dashboard | undefined
) => {
  fetch(`${RESOURCE_ADDRESS}/widgets?dashboardId=${selectedDashboard?.dashboardId}`, {
    method: "GET"
  })
    .then((res) => res.json())
    .then((data) => {
      const widgetMap = new Map<string, Widget>();
      data.forEach((item: Widget) => {
        widgetMap.set(item.widgetId!, item);
      });
      console.log('widgetMap: ', Array.from(widgetMap.values()));
      setWidgets(widgetMap);
    })
    .catch((err) => {
      console.error("Failed to fetch widgets:", err);
      setLiveDashboardErrorMsg("Failed to load widgets.");
    });
};

// CREATE widget
export const createWidget = (
  newWidget: Widget,
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>
) => {
  fetch(`${RESOURCE_ADDRESS}/widgets`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newWidget)
  })
    .then((res) => res.json())
    .then((res) => console.log("Create response:", res))
    .catch((err) => {
      console.error("Failed to create widget:", err);
      setLiveDashboardErrorMsg("Failed to create widget.");
    });
};

// UPDATE widgets
export const updateWidget = (
  widgets: Map<string, Widget>,
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>
) => {
  fetch(`${RESOURCE_ADDRESS}/widgets`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(Array.from(widgets.values()))
  })
    .then((res) => res.json())
    .then((data) => console.log("Update success:", data))
    .catch((err) => {
      console.error("Update failed:", err);
      setLiveDashboardErrorMsg("Failed to update widget(s).");
    });
};

// DELETE widget
export const deleteWidget = (
  widget: Widget,
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>
) => {
  fetch(`${RESOURCE_ADDRESS}/widgets`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ widget })
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.deletedCount > 0) {
        console.log("Deleted widget:", widget.widgetId);
      } else {
        setLiveDashboardErrorMsg("Widget could not be deleted (not found).");
      }
    })
    .catch((err) => {
      console.error("Failed to delete widget:", err);
      setLiveDashboardErrorMsg("Failed to delete widget.");
    });
};


export const deleteGridItem = (
  id: string | number,
  setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>,
  widgets: Map<string, Widget>,
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>,
) => {
  deleteWidget(widgets.get(id as string)!, setLiveDashboardErrorMsg)
  setWidgets((prevWidgets) => {
  const widgetMap = new Map(prevWidgets);
  widgetMap.delete(id as string);
  return widgetMap;
  })
}

export const addNewItem = (
  setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>, 
  newItem: Widget | undefined,
  setNewItem: React.Dispatch<SetStateAction<Partial<Widget> | undefined>>,
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>
) => {
  if (!newItem) return;

  const isEdit = !!newItem.widgetId;
  const id = isEdit ? newItem.widgetId : uuidv4();
  const key = newItem.key ?? newItem.widgetType;
  const layout = newItem.layout || newItemLayoutRules(id as string);



  const newWidget: Widget = {
    ...newItem,
    widgetId: id,
    layout,
    key
  };

  if (isEdit) {
    const newMap = new Map()
    newMap.set(newWidget.widgetId!, newWidget as Widget)
    updateWidget(newMap, setLiveDashboardErrorMsg);
  } else {
    createWidget(newWidget, setLiveDashboardErrorMsg);
  }

  setWidgets((prev) => {
    const updated = new Map(prev);
    updated.set(newWidget.widgetId!, newWidget);
    return updated;
  });

  setNewItem(undefined);
};




 



export const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  borderRadius: 6,
  // indexAxis: "y",
  scales: {
    x: {
      grid: {
        display: false, 
        drawBorder: false
      },
      ticks: {
      }
    },
    y: {
      grid: {
        display: true,   
      },
      ticks: {
        // stepSize: 1,
        precision: 0,  
      },
      beginAtZero: true,
      suggestedMin: 0
    }, 
    
  },
  plugins: {
    legend: {
      labels: {
        position: "bottom",
        pointStyle: "circle"
      },
    },
    tooltip: {
      callbacks: {
        label: function(context: any) {
          const dataset = context.dataset;
          const index = context.dataIndex;

          const metric = dataset.metricKey ?? 'Metric';
          const metricValue = dataset.metricValueNames?.[index] ?? 'Unknown';
          let delta = dataset.data?.[index] ?? 0;

          const metricFormatted = getMetricLabel(metric);
          if (metricFormatted?.toLowerCase()?.includes('time') || metricFormatted?.toLowerCase()?.includes("duration")) {
            delta = formatSecondsToDuration(delta );
          }

          return `${metricValue}: ${metricFormatted} - ${delta}`;
        }
      }
    }
  },  
}

export const barChartTimeTicks = {
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function(value: any) {
          
            // Assuming your durations are in seconds
            const minutes = Math.floor((value / 1000) / 60);
            const seconds = Math.floor((value / 1000) % 60);
            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
          
        }
      }
    }
  }}

export  const donutChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  animation: true,
  cutout: '80%', // creates the doughnut hole
  spacing: 2,
  // offset: 10,
  weight: 1,
  borderRadius: 5,
  plugins: {
    legend: {
      position: 'right',
      labels: {
        padding: 10,
        boxWidth: 12,
        pointStyle: 'circle',
        usePointStyle: true
      },
    },
      tooltip: {
        callbacks: {
        label: function(context: any) {
        const dataset = context.dataset;
        const index = context.dataIndex;

        const metric = dataset.metricKey ?? 'Metric';
        const metricValue = dataset.metricValueNames?.[index] ?? 'Unknown';
        let delta = dataset.data?.[index] ?? 0;
        const metricFormatted = getMetricLabel(metric);
        if (metricFormatted?.toLowerCase()?.includes('time') || metricFormatted?.toLowerCase()?.includes("duration")) {
          delta = formatSecondsToDuration(delta)
        }


        return `${metricValue}: ${metricFormatted} - ${delta}`;
      }
    }
  }
  },
  layout: {
    padding: 20,
  },
}

// export const relativeDoughnutChartOptions = {
//   responsive: true,
//   maintainAspectRatio: false,
//   animation: true,
//   cutout: '50%', 
//   plugins: {
//     legend: {
//       position: 'right',
//       labels: {
//         padding: 10,
//         boxWidth: 12,
//       },
//     },
//      tooltip: {
//       callbacks: {
//         label: (context: any) => {
//           const { dataset, dataIndex } = context;
//           let value = dataset?.data?.[dataIndex] || '';
//           const metric = dataset.metricKey || 'metric';
//           const metricFormatted = getMetricLabel(metric);
//           if (metric?.toLowerCase()?.includes("time") || metric?.toLowerCase()?.includes("duration")) {
//             value = formatSecondsToDuration(value)
//           }
//           const labelType = dataIndex === 0 ? 'Selected' : 'Remaining';
//           return `${labelType}: ${metricFormatted} - ${value}`;
//         }
//       }
//     },
//   },
//   layout: {
//     padding: 20,
//   },
// };

// export const relativePieChartOptions = {
//   responsive: true,
//   maintainAspectRatio: false,
//   animation: true,
//   plugins: {
//     legend: {
//       position: 'right',
//       labels: {
//         padding: 10,
//         boxWidth: 12,
//       },
//     },
//      tooltip: {
//       callbacks: {
//         label: (context: any) => {
//           const { dataset, dataIndex } = context;
//           let value = dataset.data?.[dataIndex];
//           const metric = dataset.metricKey || 'metric';
//           const metricFormatted = getMetricLabel(metric);
//           const labelType = dataIndex === 0 ? 'Selected' : 'Remaining';
//           if (metric?.toLowerCase()?.includes("time") || metric?.toLowerCase()?.includes("duration")) {
//             value = formatSecondsToDuration(value)
//           }
//           return `${labelType}: ${metricFormatted} - ${value}`;
//         }
//       }
//     },
//   },
//   layout: {
//     padding: 20,
//   },
// };

export const PieChartOptions = {
  responsive: true,
  animation: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'right',
      labels: {
        padding: 4,
        boxWidth: 10,
      },  
    }, 
     tooltip: {
        callbacks: {
        label: function(context: any) {
        const dataset = context.dataset;
        const index = context.dataIndex;

        const metric = dataset.metricKey ?? 'Metric';
        const metricValue = dataset.metricValueNames?.[index] ?? 'Unknown';
        let delta = dataset.data?.[index] ?? 0;
        const metricFormatted = getMetricLabel(metric);
        if (metricFormatted?.toLowerCase()?.includes('time') || metricFormatted?.toLowerCase()?.includes("duration")) {
          delta = formatSecondsToDuration(delta)
        }


        return `${metricValue}: ${metricFormatted} - ${delta}`;
      }
    }
  }
  },
  layout: {
    padding: 20,
  },
}


export const deltaGetter = (widget: Widget | undefined, userDeltas: any, queueDeltas: any) => {
  const {dimensionType, widgetType, quickWidgetType} = widget || {};

    if (widgetType === "quick") {
      if (quickWidgetType === "callResults" || 
        quickWidgetType === "callDirectionCount" || 
        quickWidgetType === "callDirectionTime" ||
        quickWidgetType === "topPerformersCompletedCalls"
      )
      return userDeltas;
    }
    if (dimensionType === "users") {
      return userDeltas;
    }
    if (dimensionType === "queues") {
      return queueDeltas;
    } 
    return [];
}

export const callGetter = (deltas: any) => {
  console.log("DELTAS: ", deltas);
  return "3";
}
export const queueCallsWaitingGetter = (liveQueueMetrics: Map<String, MetricObject>) => {
  if (liveQueueMetrics) {
    return Array.from(liveQueueMetrics.values()).reduce((arr, callState) => {
      if (callState?.waiting?.length) {
        arr.push(...callState.waiting);
        }
      return arr;
    }, [] as MetricObject['waiting']).length
  } 
}
export const queueCallsInProgressGetter = (liveQueueMetrics: Map<String, MetricObject>) => {
  if (liveQueueMetrics) {
    return Array.from(liveQueueMetrics.values()).reduce((arr, callState) => {
      if (callState?.inProgress?.length) {
        arr.push(...callState.waiting);
        }
      return arr;
    }, [] as MetricObject['inProgress']).length
  } 
}
export const queueMonitorLiveCallGetter = (liveQueueMetrics: Map<String, MetricObject>) => {
  if (liveQueueMetrics) {
    let waiting = 0;
    let inProgress = 0;
    Array.from(liveQueueMetrics.values()).forEach((callState) => {
       if (callState?.waiting?.length) {
          waiting++;
        }
      if (callState?.inProgress?.length) {
          inProgress++;
        }
    })
    return {
      data: [waiting, inProgress],
      labels: ["Waiting", "In Progress"]
    }
  } 
}

export const callbackRequestsGetter = (tabCounts: {voicemail: number; callback: number; abandoned: number}) => {
  const callbackRequests = tabCounts?.callback ?? 0;
  return callbackRequests;
}
export const unresolvedVoicemailGetter = (tabCounts: {voicemail: number; callback: number; abandoned: number}) => {
  const voicemail = tabCounts?.voicemail ?? 0;
  return voicemail;
}
export const abandonedCallCountGetter = (tabCounts: {voicemail: number; callback: number; abandoned: number}) => {
  const abandoned = tabCounts?.abandoned ?? 0;
  return abandoned;
}


export const callStateGetter = (
  widget: Widget | undefined, 
  liveQueueMetrics: Map<String, MetricObject>,
  tabCounts: {
    voicemail: number;
    callback: number;
    abandoned: number;
}
): any | undefined => {
  if (!widget || widget?.widgetType !== "quick") return undefined;
  if (widget.widgetType === "quick") {

    
    //CALLBACK REQUESTS
    if (widget.quickWidgetType === 'callbackRequests') {
      return tabCounts.callback;
    }
    // QUEUE VOICEMAILS
    if (widget.quickWidgetType === 'unresolvedVoicemails') {
      return tabCounts.voicemail;
    }
    // QUEUE ABANDONED
    if (widget.quickWidgetType === 'callsAbandoned') {
      return tabCounts.abandoned;
    }
    // QUEUE VOICEMAILS 
    if (widget.quickWidgetType === "voicemail") {
       return Array.from(liveQueueMetrics.values()).reduce((int, callState) => {
          if (callState.inProgress.length) {
            int += callState.voiceMail.weight;
          }
          return int;
        }, 0)
    }
    // QUEUE - ABANDONED 
    if (widget.quickWidgetType === "abandoned" || widget.quickWidgetType === 'abandonedChart') {
       return Array.from(liveQueueMetrics.values()).reduce((int, callState) => {
          if (callState?.inProgress?.length) {
            int += callState.abandoned.weight;
          }
          return int;
        }, 0)
    }
    // QUEUE ANSWERED
    if (widget.quickWidgetType === "answered" || widget.quickWidgetType === 'answeredChart') {
       return Array.from(liveQueueMetrics.values()).reduce((int, callState) => {
          if (callState?.inProgress?.length) {
            int += callState?.answered?.weight;
          }
          return int;
        }, 0)
    }

    // QUEUE IN PROGRESS ✅ 
    if (widget.quickWidgetType === "inProgress" || widget.quickWidgetType === "inProgressChart") {
      return Array.from(liveQueueMetrics.values()).reduce((arr, callState) => {
          if (callState?.inProgress?.length) {
            arr.push(...callState.inProgress);
          }
          return arr;
        }, [] as MetricObject['inProgress'])
  
    }
    // QUEUE WAITING ✅    
    if (widget?.quickWidgetType === "waiting" || widget.quickWidgetType === "waitingChart") {
     return Array.from(liveQueueMetrics.values()).reduce((arr, callState) => {
          if (callState?.waiting?.length) {
            arr.push(...callState.waiting);
       }
          return arr;
        }, [] as MetricObject['waiting'])
  
  
    } else {
      return undefined;
    }
  } else {
      return undefined;
  }
}



export const populatePieRelativeData = (selected: number, remainder: number, relativeChartColors: string[], metric: string) => {
  const totalData = [selected, remainder]
  return {
    data: totalData,
    backgroundColor: relativeChartColors,
    borderColor: relativeChartColors,
    metricKey: metric,
    metricLabel: getMetricLabel(metric)
  } 
}

export const isWidgetValid = (widget?: Partial<Widget>): boolean => {
  if (!widget) return false;

  const hasTitle = widget.title !== undefined && widget.title.trim() !== "";
  const hasDimension = !!widget.dimensionType;
  const hasMetrics = Array.isArray(widget.metrics)
    ? widget.metrics.length > 0
    : !!widget.metrics;

  if (widget.widgetType === "kpi") {
    return hasTitle && hasDimension && hasMetrics;
  }

  if (widget.widgetType === "customized") {
    const isPieOrDonut = widget.visualType === "pie" || widget.visualType === "donut";
    const isBar = widget.visualType === "bar";
    const hasMetricValues = Array.isArray(widget.metricValues) && widget.metricValues.length > 0;

    if ((isPieOrDonut) || (!isPieOrDonut && !isBar)) return false;

    return hasTitle && hasDimension && hasMetrics && hasMetricValues;
  }

  if (widget.widgetType === "quick") {
    const hasAQuickWidget = widget.quickWidgetType !== null || widget.quickWidgetType !== undefined || widget.quickWidgetType !== "--";
    if (hasAQuickWidget) {
      return true;
    } else {
      return false;
    }
  }

  return false;
};


export function formatSecondsToDuration(ms: number): string {
  const totalSeconds = ms / 1000;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const pad = (n: number) => n.toString().padStart(2, '0');

  if (hours > 0) {
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  } else {
    return `${pad(minutes)}:${pad(seconds)}`;
  }
}



export const availableUserMetrics = [
    { key: "count", label: "Call Count", type: "count" },
    { key: "hangupCount", label: "Hangup Count" , type: "count"},
    { key: "missedCount", label: "Missed Call Count", type: "count" },
    { key: "ringCountInbound", label: "Ring Count (Inbound)", type: "count" },
    { key: "ringCountInternal", label: "Ring Count (Internal)", type: "count" },
    { key: "ringCountOutbound", label: "Ring Count (Outbound)", type: "count" },
    { key: "talkCountInbound", label: "Talk Count (Inbound)", type: "count" },
    { key: "talkCountInternal", label: "Talk Count (Internal)", type: "count" },
    { key: "talkCountOutbound", label: "Talk Count (Outbound)", type: "count" },
    { key: "holdCountInbound", label: "Hold Count (Inbound)", type: "count" },
    { key: "holdCountOutbound", label: "Hold Count (Outbound)" , type: "count"},
    { key: "vmCount", label: "Voicemail Count", type: "count" },
    { key: "vmLeftCount", label: "Voicemails Left", type: "count" },
    { key: "duration", label: "Total Duration" , type: 'time'},
    { key: "missedTime", label: "Missed Call Time" , type: 'time'},
    { key: "ringTimeInbound", label: "Ring Time (Inbound)", type: 'time' },
    { key: "ringTimeInternal", label: "Ring Time (Internal)", type: 'time' },
    { key: "ringTimeOutbound", label: "Ring Time (Outbound)" , type: 'time'},
    { key: "talkTimeInbound", label: "Talk Time (Inbound)" , type: 'time'},
    { key: "talkTimeInternal", label: "Talk Time (Internal)", type: 'time' },
    { key: "talkTimeOutbound", label: "Talk Time (Outbound)", type: 'time' },
    { key: "holdTimeInbound", label: "Hold Time (Inbound)", type: 'time' },
    { key: "holdTimeOutbound", label: "Hold Time (Outbound)", type: 'time' },
    { key: "vmDurationTime", label: "Voicemail Duration Time", type: 'time' },
    { key: "vmGreetingTime", label: "Voicemail Greeting Time", type: 'time' },
];

export const availableQueueMetrics = [
    { key: "abandonedCount" , label: "Abandoned Count", type: "count"},
    { key: "count", label: "Call Count", type: "count" },
    { key: "hangupCount", label: "Hangup Count" , type: "count"},
    { key: "missedCount", label: "Missed Call Count", type: "count" },
    { key: "ringCountInbound", label: "Ring Count (Inbound)" , type: "count"},
    { key: "ringCountInternal", label: "Ring Count (Internal)" , type: "count"},
    { key: "holdCountInbound", label: "Hold Count (Inbound)" , type: "count"},
    { key: "voicemailCount", label: "Voicemail Count" , type: "count"},
    { key: "abandonedTime", label: "Abandoned Time", type: 'time'},
    { key: "duration", label: "Total Duration", type: "time" },
    { key: "maxDuration", label: "Longest Duration", type: "max"},
    { key: "missedTime", label: "Missed Call Time",  type: "time" },
    { key: "ringTimeInbound", label: "Ring Time (Inbound)" ,  type: "time"},
    { key: "ringTimeInternal", label: "Ring Time (Internal)",  type: "time" },
    { key: "holdTimeInbound", label: "Hold Time (Inbound)" ,  type: "time"},
    { key: "vmGreetingTime", label: "Voicemail Greeting Time",  type: "time" },
    { key: "voicemailTime", label: "Voicemail Duration Time",  type: "time" },
];

export const getMetricLabel = (key: string | undefined): string | undefined => {
  const label = Object.values(availableQueueMetrics).flat().find((metric) => metric.key === key)?.label;
  return label || key;
};

export const dummyDataset = {
  data: {
    labels: ["1", "2", "3"],
    datasets: [
      {
        data: [4, 2, 6],
        backgroundColor: ['#ffffff33', "#ffffff88", "#ffffff00"],
        borderColor: ['#fff'],
        borderWidth: 1,
      },
    ],
  },
  options: {
    responsive: true,
    // scales: {
    //   x: {
    //     ticks: {
    //       display: true, // hide bottom ticks
    //     },
    //     grid: {
    //       display: false, // hide x-axis grid lines
    //       drawBorder: true, // no border line
    //     },
    //   },
    //   y: {
    //     ticks: {
    //       display: false, // hide left ticks
    //     },
    //     grid: {
    //       display: false, // hide y-axis grid lines
    //       drawBorder: false, // no left border
    //     },
    //   },
    // },
    // plugins: {
    //   legend: {
    //     display: false,
    //   },
    //   tooltip: {
    //     enabled: false,
    //   },
    // },
  },
};

export const addMetricsToNewWidget = (
  value: string,
  newWidget: Partial<Widget> | undefined,
  setNewWidget: React.Dispatch<React.SetStateAction<Partial<Widget> | undefined>>,
  field: 'metrics' | 'metricValues'
) => {
  setNewWidget((prev) => {
    if (!prev) return prev;
    const newConfig = prev;
    const existingValues = newConfig[field] ?? [];
    const newValues = existingValues.includes(value) ? existingValues.filter((v) => v !== value) : [...existingValues, value]; 

   if (newWidget && newWidget.widgetType && newWidget.widgetType === "customized") {
     return {
      ...newConfig,
      [field]: newValues,
    };
   } else if (newWidget && newWidget?.widgetType && newWidget?.widgetType === 'kpi') {
    console.log("KPI values:", { ...newConfig, [field]: [value],})
     return {
      ...newConfig,
      [field]: [value],
    };
   } else {
     return {
      ...prev,
      [field]: newValues,
    };
   }
  });
};


export const NewWidgetItemContainer = ({children, title, styles, subtext, width}: {width?: number; children: React.ReactNode, title: string; styles: Record<string, string> , subtext?: string}) => {
  return (
  <div className={styles.newWidgetItemBox} style={{flex: width === 2 ? "0 0 calc(100% - 1rem)" : "0 0 calc(50% - 1rem)", maxWidth: width === 2 ? "calc(100% - 1rem)" : "calc(50% - 1rem)" }}>
    <span className={styles.newWidgetItemLabel}>{title}</span>
      {children}
    <span>{subtext}</span>
  </div>
  )
}
NewWidgetItemContainer.defaultProps = {
  subtext: undefined
}


// custom plugins
export const needle = {
  id: "needle",
  afterDatasetsDraw(chart: any) {
  const { ctx } = chart;
  const width = chart.width;
  const height = chart.height;
    const meta = chart.getDatasetMeta(0);
    if (!meta || !meta.data[0]) return;

    const xCenter = meta.data[0].x;
    const yCenter = meta.data[0].y;
    const outerRadius = meta.data[0].outerRadius - 6;

    ctx.save();
    ctx.translate(xCenter, yCenter);
    ctx.rotate(Math.PI / 3.05); // rotate 90 degrees clockwise

    // Draw the needle triangle
    ctx.beginPath();
    ctx.moveTo(-3, 3);
    ctx.lineTo(0, -outerRadius - 4);
    ctx.lineTo(3, 3);
    ctx.closePath();
    ctx.fillStyle = "#90b7bc";
    ctx.strokeStyle = "#90b7bc";
    ctx.stroke();
    ctx.fill();

    // Draw the center circle
    ctx.beginPath();
    ctx.arc(0, 0, 6, 0, Math.PI * 2);
    ctx.fill();

    ctx.restore();

     // Draw centered text
    const fontSize = (chart.height / 164).toFixed(2);
    ctx.font = `${fontSize}em Helvetica`;
    ctx.fillStyle = "#86CF6Ec0";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("4.1", width / 2, height / 2);
  },
};